/**
 * @generated SignedSource<<0379621dfc1e714f5e3c3fa3760fb105>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdatePoliticalViewCriteriaInput = {
  clientMutationId?: string | null | undefined;
  politicalViewIds?: ReadonlyArray<any | null | undefined> | null | undefined;
};
export type usePoliticalViewCriteriaMutation$variables = {
  input: UpdatePoliticalViewCriteriaInput;
};
export type usePoliticalViewCriteriaMutation$data = {
  readonly updatePoliticalViewCriteria: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"usePoliticalViewCriteria_query">;
    } | null | undefined;
  } | null | undefined;
};
export type usePoliticalViewCriteriaMutation = {
  response: usePoliticalViewCriteriaMutation$data;
  variables: usePoliticalViewCriteriaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePoliticalViewCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdatePoliticalViewCriteriaPayload",
        "kind": "LinkedField",
        "name": "updatePoliticalViewCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "usePoliticalViewCriteria_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "usePoliticalViewCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdatePoliticalViewCriteriaPayload",
        "kind": "LinkedField",
        "name": "updatePoliticalViewCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "POLITICAL_VIEW_BY_POLITICAL_VIEW_ID__SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "PoliticalViewCriterionConnection",
                    "kind": "LinkedField",
                    "name": "politicalViewCriteria",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PoliticalViewCriterion",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "politicalViewId",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "politicalViewCriteria(orderBy:[\"POLITICAL_VIEW_BY_POLITICAL_VIEW_ID__SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "85076337614eb21604a3a9a8f4c2ddbe",
    "id": null,
    "metadata": {},
    "name": "usePoliticalViewCriteriaMutation",
    "operationKind": "mutation",
    "text": "mutation usePoliticalViewCriteriaMutation(\n  $input: UpdatePoliticalViewCriteriaInput!\n) {\n  updatePoliticalViewCriteria(input: $input) {\n    query {\n      ...usePoliticalViewCriteria_query\n      id\n    }\n  }\n}\n\nfragment usePoliticalViewCriteria_query on Query {\n  currentUser {\n    politicalViewCriteria(orderBy: [POLITICAL_VIEW_BY_POLITICAL_VIEW_ID__SEQUENCE_ASC]) {\n      nodes {\n        politicalViewId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a9cc71e584eaefea149ea38c60c0abd";

export default node;
